<script setup>
import { ref } from 'vue';

import ListingCard from '@/components/Secondary/Marketplace/ListingCard.vue';
import SideNav from './_helpers/layout/SideNav.vue';
import { collectionV2 } from '@/composables/resource';
import { filters, selectFilter, switchFilter } from '@/composables/data-view/collection.js';
import ComingSoon from '@/components/ComingSoon.vue';

const open = ref(false);
const viewFilters = filters(
    selectFilter({
        name: 'category_id',
        label: 'Category',
        props: {
            options: '/api/marketplace/listing-categories',
            placeholder: 'Choose a category',
        }
    }),
    selectFilter({
        name: 'state_id',
        label: 'Location',
        props: {
            options: '/api/states',
            placeholder: 'Choose a location',
        }
    }),
    switchFilter({
        name: 'verified_sellers',
        label: 'Show only verified sellers',
    }),
    selectFilter({
        name: 'sort',
        props: {
            options: {
                suggested: 'Suggested',
                new_listings: 'New Listings',
                lowest_price: 'Lowest Price',
                highest_price: 'Highest Price',
            },
            default: 'suggested',
        }
    }),
);

const views = [
    {
        key: 'default',
        collection: collectionV2({
            url: '/api/marketplace/listings',
        }),
    }
];
</script>

<template>
    <layout-main>
        <head-title value="Marketplace" />
        <SideNav v-if="$store.state.showMarketplace" v-model:open="open" />
        <layout-content>
            <content-header v-if="$store.state.showMarketplace">
                <top-nav>
                    <top-nav-title>
                        Marketplace
                    </top-nav-title>

                    <div class="grow"></div>


                    <div v-if="$store.state.deviceType !== 'desktop'" class="relative">
                        <app-icon-button :icon="open ? 'cancel' : 'menu'" @click="open = !open" />
                        <app-badge v-if="$store.state.unreadMarketplaceChats" class="absolute top-3 right-3" />
                    </div>
                </top-nav>
            </content-header>

            <content-body>
                <div class="px-4 py-4" v-if="!$store.state.showMarketplace">
                    <ComingSoon />
                </div>
                <div v-else class="px-4 py-4">
                    <app-collection-view :views="views" :filters="viewFilters">

                        <template #filter-controls="{ activeView }">
                            <app-search :default="activeView.search" @submit="(search) => {
                                activeView.setSearch(search);
                                activeView.fetch();
                            }" placeholder="Search in marketplace" context="marketplace">
                                <app-search-bar>
                                    <template #trailingItems>
                                        <app-collection-filter-trigger>
                                            <app-search-bar-icon as="div" value="filter-outline" />
                                        </app-collection-filter-trigger>
                                    </template>
                                </app-search-bar>
                            </app-search>
                        </template>

                        <template #default="{ activeView }">
                            <ul class="grid grid-cols-2 md:grid-cols-3 gap-4">
                                <li v-for="listing in activeView.data" :key="listing.id">
                                    <ListingCard :data="listing" />
                                </li>
                            </ul>
                        </template>
                    </app-collection-view>
                </div>
            </content-body>
        </layout-content>
    </layout-main>
</template>
